import {
    FETCH_INVOICE_LIST_REQUEST,
    FETCH_INVOICE_LIST_SUCCESS,
    FETCH_INVOICE_LIST_ERROR,
    SHOW_INVOICE_LOADER,
    HIDE_INVOICE_LOADER,
    DOWNLOAD_INVOICE_FILE_SUCCESS,
    DOWNLOAD_INVOICE_FILE_ERROR,
    GENERATE_REPORT_INVOICE_SUCCESS,
    GENERATE_REPORT_INVOICE_ERROR,
    GENERATE_REPORT_INVOICE_REQUEST,
    DOWNLOAD_INVOICE_FILE_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS,
    UPDATE_INVOICE_PAYMENT_STATUS_ERROR,
    UPDATE_INVOICE_PAYMENT_STATUS_RESET,
} from './invoice.constants';

export const fetchInvoiceDataRequest = payload => ({
    type: FETCH_INVOICE_LIST_REQUEST,
    payload,
});

export const fetchInvoiceDataSuccess = payload => ({
    type: FETCH_INVOICE_LIST_SUCCESS,
    payload,
});

export const fetchInvoiceDataError = payload => ({
    type: FETCH_INVOICE_LIST_ERROR,
    payload,
});

export const updateInvoicePaymentStatusRequest = payload => ({
    type: UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
    payload,
});

export const updateInvoicePaymentStatusSuccess = payload => ({
    type: UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS,
    payload,
});

export const updateInvoicePaymentStatusError = payload => ({
    type: UPDATE_INVOICE_PAYMENT_STATUS_ERROR,
    payload,
});

export const updateInvoicePaymentStatusReset = payload => ({
    type: UPDATE_INVOICE_PAYMENT_STATUS_RESET,
    payload,
});

export const generateInvoiceReportRequest = payload => ({
    type: DOWNLOAD_INVOICE_FILE_REQUEST,
    payload,
});

export const generateInvoiceReportError = payload => {
    return { type: DOWNLOAD_INVOICE_FILE_ERROR, payload };
};

export const generateInvoiceReportSuccess = payload => {
    return {
        type: DOWNLOAD_INVOICE_FILE_SUCCESS,
        payload,
    };
};

export const generateInvoiceRequest = payload => ({
    type: GENERATE_REPORT_INVOICE_REQUEST,
    payload,
});

export const generateInvoiceSuccess = payload => ({
    type: GENERATE_REPORT_INVOICE_SUCCESS,
    payload,
});

export const generateInvoiceError = payload => ({
    type: GENERATE_REPORT_INVOICE_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_INVOICE_LOADER });

export const hideLoader = () => ({ type: HIDE_INVOICE_LOADER });
